import { ITag } from "../../../models/ITag";
import { IFile } from "../../../models/IFile";
import { IConversation } from "../../../models/IConversation";
import { IWorkspaceLibraryDocument } from "../../manageWorkspaces/workspaceLibrary/workspaceLibrary.types";

export interface IManageContentProps {
  isOpen: boolean;
  isPersonalWorkspace: boolean;
  onClose: () => void;
  knowledgeComponents: ITag[];
  selectedKnowledgeComponents: ITag[];
  onKnowledgeComponentsChange: (tags: ITag[]) => void;
  workspaceDocuments: IWorkspaceLibraryDocument[];
  selectedWorkspaceDocuments: IWorkspaceLibraryDocument[];
  onWorkspaceDocumentsChange: (docs: IWorkspaceLibraryDocument[]) => void;
  uploadedDocuments: IFile[];
  onUploadedDocumentsChange: (files: IFile[]) => void;
  availableConversations: IConversation[];
  selectedConversations: IConversation[];
  onConversationsChange: (conversations: IConversation[]) => void;
  workspaceId?: string;
  workspaceName?: string;
  onWorkspaceDocumentsRefresh?: () => Promise<void>;
  isLoadingKnowledgeComponents?: boolean;
  isLoadingWorkspaceDocuments?: boolean;
  isLoadingConversations?: boolean;
}

export interface IManageContentTabKey {
  KNOWLEDGE_COMPONENTS: "knowledgeComponents";
  WORKSPACE_DOCUMENTS: "workspaceDocuments";
  UPLOADED_DOCUMENTS: "uploadedDocuments";
  REFERENCED_CHATS: "referencedChats";
}

export const MANAGE_CONTENT_TABS: IManageContentTabKey = {
  KNOWLEDGE_COMPONENTS: "knowledgeComponents",
  WORKSPACE_DOCUMENTS: "workspaceDocuments",
  UPLOADED_DOCUMENTS: "uploadedDocuments",
  REFERENCED_CHATS: "referencedChats",
};

export interface IKnowledgeComponentGroup {
  categoryName: string;
  items: ITag[];
}

export interface ITabContentProps {
  knowledgeComponents: ITag[];
  selectedKnowledgeComponents: ITag[];
  onKnowledgeComponentsChange: (tags: ITag[]) => void;
  workspaceDocuments: IWorkspaceLibraryDocument[];
  selectedWorkspaceDocuments: IWorkspaceLibraryDocument[];
  onWorkspaceDocumentsChange: (docs: IWorkspaceLibraryDocument[]) => void;
  uploadedDocuments: IFile[];
  onUploadedDocumentsChange: (files: IFile[]) => void;
  availableConversations: IConversation[];
  selectedConversations: IConversation[];
  onConversationsChange: (conversations: IConversation[]) => void;
  workspaceId?: string;
  workspaceName?: string;
  onWorkspaceDocumentsRefresh?: () => Promise<void>;
  isLoadingKnowledgeComponents?: boolean;
  isLoadingWorkspaceDocuments?: boolean;
  isLoadingConversations?: boolean;
}
